import { Lightning } from '@lightningjs/sdk';

/**
 * This should replace all instances of TextTexture templates and be our universal Text component
 */
export default class TextLabel extends Lightning.Component {
  override get text(): Lightning.textures.TextTexture | null {
    return super.text;
  }

  override set text(value: Lightning.textures.TextTexture) {
    // Manually set component dimensions to fix Vizio text stretching EL-231
    if (super.texture) {
      const { w, h } = super.texture;

      if (this.w !== w || this.h !== h) {
        this.patch({ w, h });
      }
    }

    super.text = value;
  }

  static override _template(): Lightning.Component.Template {
    return {};
  }
}
